export default __webpack_public_path__ + "static/media/profile.2cff96e8.jpg";